import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-frequency-matrix-dialog',
  standalone: false,
  templateUrl: './confirm-frequency-matrix-dialog.component.html',
})
export class ConfirmFrequencyMatrixDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmFrequencyMatrixDialogComponent>,
  ) {}

  public continue(): void {
    this.dialogRef.close(true);
  }

  public cancel(): void {
    this.dialogRef.close(false);
  }
}
